import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// CONFIGS
import { CountryConfig } from 'app/core/_config/country.config';

type UiCountriesComponentCountryCode = keyof typeof CountryConfig.countries;
type UiCountriesComponentCountryName = typeof CountryConfig.countries;
interface IUiCountriesComponentOption {
  code :string;
  name :string;
}

const CODES = Object.keys(CountryConfig.countries);
const OPTIONS = Object.entries(CountryConfig.countries).map(
  ([code, name]) :IUiCountriesComponentOption => ({ code, name }),
);

@Component({
  selector: 'cnc-ui-countries',
  templateUrl: './ui-countries.component.html',
  styleUrls: ['./ui-countries.component.scss'],
})
export class UiCountriesComponent implements OnInit {
  @Input() initialValue :UiCountriesComponentCountryCode | 'USA';
  @Input() disabled :boolean = false;
  @Input() required :boolean = false;

  @Output() changeCountry = new EventEmitter<
    UiCountriesComponentCountryCode | string
  >();

  countries :IUiCountriesComponentOption[] = OPTIONS;
  selectedValue :UiCountriesComponentCountryCode | string = 'US';

  constructor() {}

  ngOnInit() :void {
    if (this.initialValue === 'USA') {
      // normalize `USA` to `US`
      this.selectedValue = 'US';
    } else if (
      this.initialValue !== this.selectedValue &&
      CODES.includes(this.initialValue)
    ) {
      this.selectedValue = this.initialValue;
    }
  }

  ngAfterViewInit() :void {
    // Emit the event after init to keep parents in-the-loop. [calvin]
    this.changeCountry.emit(this.selectedValue);
  }

  onCountryChange(selection :IUiCountriesComponentOption) :void {
    this.selectedValue = selection?.code ?? '';
    this.changeCountry.emit(this.selectedValue);
  }
}
